import React, { useCallback, useEffect, useState } from "react";

import Text from "../../../Text";
import CardUpgrade from "../CardUpgrade";

import { useManagerTrial } from "../../context/contextManagerTrial";
import CarrousselView from "components/PeopleCraft/CarrousselView";

const RequestUpgrade = ({}) => {
  const [showBtnDetail, setShowBtnDetail] = useState<boolean>(false);
  const [showDetail, setshowDetail] = useState<boolean>(false);

  const { listPlans } = useManagerTrial();

  useEffect(() => {
    listPlans?.map((elem, index) => {
      if (elem.products && elem.products.length > 0) {
        setShowBtnDetail(true);
      }
      return elem;
    });
  }, [listPlans]);
  return (
    <>
      <div className="title">
        <Text component={"h3"} text={"Comece sua degustação"} />
        <Text
          className="subtitle-upgrade"
          component={"p"}
          text={
            "Desenvolva e aprimore seus próprios programas de treinamento, com acesso exclusivo a uma ampla variedade de biblioteca, proporcionando um acervo rico em conteúdo e recursos de aprendizado."
          }
        />
      </div>

      <div className={`carroussel`}>
        {listPlans?.length && (
          <CarrousselView
            options={{
              cellAlign: "center",
              selectedAttraction: 1,
              friction: 1,
              contain: true,
            }}
            reloadOnUpdate={false}
          >
            {listPlans.map((elem, index) => (
              <CardUpgrade key={`card-upgrade-${index}`} showDetail={showDetail} elem={elem} />
            ))}
          </CarrousselView>
        )}
      </div>
      {showBtnDetail && (
        <button className="showDetail" onClick={(e) => setshowDetail(!showDetail)}>
          Ver {!showDetail ? "mais" : "menos"} detalhes
        </button>
      )}
    </>
  );
};

export default RequestUpgrade;
